import ContentContainer from 'components/content-container';
import { useIsBreakpointWidth } from 'lib/hooks/useIsBreakpointWidth';
import { motion } from 'motion/react';
import { loadingVariants, skeletonVariants } from '../animations';

interface LoadingStateProps {
  sliceType: string;
  sliceVariation: string;
}

export function LoadingState({ sliceType, sliceVariation }: LoadingStateProps) {
  const isMobileWidth = useIsBreakpointWidth({
    size: 'sm',
    breakPointType: 'tui'
  });

  return (
    <motion.section
      data-slice-type={sliceType}
      data-slice-variation={sliceVariation}
      className="bg-white"
      variants={loadingVariants}
      initial="hidden"
      animate="visible"
    >
      <ContentContainer className="relative pb-12" noPadding={isMobileWidth}>
        <div className="animate-pulse">
          <motion.div
            className="flex items-center justify-between border-t-thin border-black pb-4 pt-3 xs-tui:pl-5 sm-tui:pl-0"
            variants={skeletonVariants}
          >
            <div className="rounded h-6 w-32 bg-gray-200" />
          </motion.div>
          <motion.div
            className="rounded mb-4 h-12 w-48 bg-gray-200"
            variants={skeletonVariants}
          />
          <div className="flex flex-col gap-8 lg-tui:flex-row">
            <motion.div className="flex-1" variants={skeletonVariants}>
              <div className="rounded mb-4 aspect-video bg-gray-200" />
              <div className="rounded mb-2 h-8 bg-gray-200" />
              <div className="rounded h-4 w-3/4 bg-gray-200" />
            </motion.div>
            <motion.div
              className="w-full space-y-4 lg-tui:w-80"
              variants={skeletonVariants}
            >
              {[...Array(4)].map((_, index) => (
                <motion.div
                  key={index}
                  className="rounded h-24 bg-gray-200"
                  variants={skeletonVariants}
                />
              ))}
            </motion.div>
          </div>
        </div>
      </ContentContainer>
    </motion.section>
  );
}
